<script setup lang="ts">
import { Toaster } from "@/components/ui/sonner";
import "vue-sonner/style.css";
</script>

<template>
  <NuxtLoadingIndicator color="#FCAE3F" />
  <main class="w-full h-screen">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </main>
  <Toaster :expand="true" rich-colors class="pointer-events-auto" />
</template>
